var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gallery",staticClass:"gallery"},_vm._l((_vm.repeatedGallery(_vm.data.value.gallery)),function(item,index){return _c('div',{key:index,class:['item', item.width > item.height ? 'item-w' : 'item-h']},[_c('Figure',{attrs:{"data":{
        value: {
          image: item,
        },
        settings: {},
      },"lazyload":false,"disable-ratio":"","theme":item.width > item.height ? 'gallery-w' : 'gallery-h'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }